import { Shield } from "lucide-react";

export const Footer = () => (
    <footer
        data-testid="vanguard-footer"
        className="border-t border-zinc-800/80 mt-24 bg-black/95"
    >
        <div className="max-w-[1600px] mx-auto px-6 md:px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="relative w-10 h-10 border border-gold-300 flex items-center justify-center">
                            <Shield className="w-4 h-4 text-gold-300" />
                        </div>
                        <div>
                            <div className="font-black uppercase tracking-[0.2em] text-white">
                                Vanguard Command
                            </div>
                            <div className="label-tactical mt-1">Total Force Vessel · v1.0</div>
                        </div>
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
                        The full-spectrum DoD lifecycle hub for service members navigating the
                        crosswalk from uniform to sovereign operator. 90% Exoskeleton automation.
                        10% Strategic Signal.
                    </p>
                </div>
                <div>
                    <div className="label-tactical mb-4">MODULES</div>
                    <ul className="space-y-2 text-sm text-zinc-400">
                        <li>MOS-to-Armada Crosswalk</li>
                        <li>Benefits Vault</li>
                        <li>Recruiter Shield</li>
                        <li>Transition Strike</li>
                        <li>Sovereign Pace Tracker</li>
                    </ul>
                </div>
                <div>
                    <div className="label-tactical mb-4">REGULATIONS</div>
                    <ul className="space-y-2 text-sm text-zinc-400">
                        <li>AR 621-5 (2026)</li>
                        <li>Army COOL Structure</li>
                        <li>Post-9/11 GI Bill (Ch. 33)</li>
                        <li>SkillBridge DoDI 1322.29</li>
                    </ul>
                </div>
            </div>
            <div className="gold-divider mt-12 mb-6" />
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                    © 2026 EIGOO INC · Vanguard.eigooinc.net · Built for the Billion-Dollar Armada
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                        Operational Status
                    </span>
                    <span className="w-1.5 h-1.5 bg-emerald-400 animate-pulse" />
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
